<template>
  <div>
    <button
      @click="openDropdown"
      class="border-[1px] border-solid border-white flex items-center justify-center rounded-full px-4 py-2 hover:bg-[#003F82] focus:bg-[#003F82] transition-colors"
      :class="{ 'hover:bg-white focus:bg-white bg-white text-[#003F82]': isOpen }"
      role="button"
    >
      <span class="hidden min-[1440px]:!block pl-2"> Browse all treatments </span>
      <span class="block min-[1440px]:hidden"> All treatments </span>
      <ChevronUp v-if="isOpen" class="w-6 h-6" />
      <ChevronDown v-else class="w-6 h-6 text-white" />
    </button>
    <transition
      enter-from-class="!opacity-0"
      enter-to-class="!opacity-100"
      enter-active-class="transition duration-200 !opacity-0"
      leave-to-class="!opacity-0"
      leave-active-class="transition duration-200"
    >
      <div
        class="absolute mt-3 bg-white z-[999] w-screen left-0 right-0 rounded-b-[40px] overflow-hidden text-[#003F82] shadow-[0_2px_12px_0px_rgba(0,0,0,0.4)]"
        role="dialog"
        v-show="isOpen"
        ref="treatmentContainer"
      >
        <div
          class="mx-auto max-w-[1140px] grid gap-y-10 px-6 min-[1024px]:px-12 min-[1440px]:px-0 py-8 md:grid-cols-3 min-[1024px]:grid-cols-5 gap-x-[35px]"
        >
          <div v-for="item in props.content.items" :key="item.label">
            <a
              v-if="item.href"
              :href="item.href"
              class="relative block font-bold after:absolute after:-bottom-1 after:left-0 after:right-0 after:h-[2px] after:w-full after:bg-[#003F82] after:content-[''] hover:no-underline"
            >
              {{ item.label }}
            </a>
            <p
              v-else
              class="relative pointer-events-none font-bold after:absolute after:-bottom-1 after:left-0 after:right-0 after:h-[2px] after:w-full after:bg-[#003F82] after:content-[''] hover:no-underline"
            >
              {{ item.label }}
            </p>
            <ul class="mt-5 space-y-2" v-if="isNavigationCategoryItem(item)">
              <li v-for="secondaryItem in item.items" :key="secondaryItem.label">
                <a :href="secondaryItem.href" class="text-[#3C80DF] hover:underline">
                  {{ secondaryItem.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import ChevronDown from "../../../resources/chevron-down.svg?inline";
import ChevronUp from "../../../resources/chevron-up.svg?inline";
import { isNavigationCategoryItem, type DRXNavigationContent } from "../types";
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";

const props = defineProps<{
  content: DRXNavigationContent["primaryExpandedContent"];
}>();

const isOpen = ref(false);
const treatmentContainer = ref(null);

const openDropdown = () => {
  isOpen.value = true;
};

onClickOutside(treatmentContainer, (event) => {
  if (isOpen.value) {
    event.stopPropagation();
    isOpen.value = false;
  }
});
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
